import React, { FC, useEffect, useState } from "react";
import FooterButtons from "../customhtmlcomponents/FooterButtons";
import { ResponseData } from "../adminpanel/panels/types/types";
import { useForm } from "react-hook-form";
import axios from "../../services/ApiConfig";
import { useHistory } from "react-router-dom";
import { URLS } from "../../utility/UrlConstants";
import NavigationBar from "../NavigationBar";
import getRapportAar from "../../utility/dateUtils";

interface IAktivitetProps {
  currentForeningReportNumber: number;
  username: string;
  message: React.Dispatch<React.SetStateAction<{ body: ResponseData }>>;
  setModal: React.Dispatch<React.SetStateAction<boolean>>;
}

type AktivitetState = {
  ar: number;
  foreningsNummer: number;

  kloverTurForrigeAr: string;
  kloverTurNavaerendeAr: string;

  ressursVennForrigeAr: string;
  ressursVennNavaerendeAr: string;

  omsorgBeredskapForrigeAr: string;
  omsorgBeredskapNavaerendeAr: string;

  moterOmKvinnehelseForrigeAr: string;
  moterOmKvinnehelseNavaerendeAr: string;

  helsedagerForrigeAr: string;
  helsedagerNavaerendeAr: string;

  motherhoodForrigeAr: string;
  motherhoodNavaerendeAr: string;

  kanskjeKommerKongenForrigeAr: string;
  kanskjeKommerKongenNavaerendeAr: string;

  brannsikkerhetForEldreForrigeAr: string;
  brannsikkerhetForEldreNavaerendeAr: string;

  egenberedskapForrigeAr: string;
  egenberedskapNavaerendeAr: string;

  forsteHjelpForEldreForrigeAr: string;
  forsteHjelpForEldreNavaerendeAr: string;

  annet: string;
  annetJaNei: string;
};

type ActivityRow = {
  displayName: string;
  fieldName: string;
  fieldNameNextYear: string;
};

const Aktivitet: FC<IAktivitetProps> = ({
  currentForeningReportNumber,
  username,
  message,
  setModal,
}) => {
  const { register, setValue, handleSubmit, errors, getValues } =
    useForm<AktivitetState>();
  const [aar, setAar] = useState(getRapportAar);
  const [forrigeAr, setForrigeAr] = useState(getRapportAar - 1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const history = useHistory();
  const saveSuccessMessage = () => {
    message({
      body: {
        body: {
          message: `Aktiviteter ble lagret.`,
        },
      },
    });
    setModal(true);
    setTimeout(() => setModal(false), 2000);
  };
  const saveOnClick = async (e: React.BaseSyntheticEvent, link: string) => {
    await handleNavBarClick().then(() => history.push(link));
  };
  const handleNavBarClick = handleSubmit<AktivitetState>(async (getValues) => {
    postFormData(getValues, false);
  });

  const postFormData = async (getValues: any, redirectToNextPage: boolean) => {
    const values = {
      ...getValues,
      foreningsNummer: currentForeningReportNumber,
    };
    setIsSubmitting(true);
    axios
      .post(URLS.AKTIVITET_POST, values)
      .then((response) => {
        console.log(response);
        saveSuccessMessage();

        if (redirectToNextPage) {
          setTimeout(
            () =>
              {
                setIsSubmitting(false);
                history.push({
                  pathname: "/kos",
                  state: currentForeningReportNumber,
                })
              },
            1750
          );
        }

      })
      .catch((error) => {
        console.log(error?.response?.data);
        message({
          body: {
            body: {
              error: "Dessverre feilet lagring av Aktiviteter. Vennligst sjekk at alle felter er fylt inn med rett verdi og prøv igjen.",
            },
          },
        });
        setModal(true);
        setTimeout(() => {
          setModal(false)
          setIsSubmitting(false)
        }, 5000);
      });
  }

  const kvinnehelseAktiviter: Array<ActivityRow> = [
    {
      fieldName: "moterOmKvinnehelseForrigeAr",
      fieldNameNextYear: "moterOmKvinnehelseNavaerendeAr",
      displayName: "Åpne møter/arrangementer/foredrag om kvinnehelse rettet mot befolkningen utover egne medlemmer",
    },
    {
      displayName: "Språkvenn",
      fieldName: "sprakVennForrigeAr",
      fieldNameNextYear: "sprakVennNavaerendeAr",
    },
    {
      displayName: "Helsedager for innvandrede kvinner",
      fieldName: "helsedagerForrigeAr",
      fieldNameNextYear: "helsedagerNavaerendeAr",
    },
    {
      displayName: "Motherhood",
      fieldName: "motherhoodForrigeAr",
      fieldNameNextYear: "motherhoodNavaerendeAr",
    },
    {
      displayName: "Ressursvenn",
      fieldName: "ressursVennForrigeAr",
      fieldNameNextYear: "ressursVennNavaerendeAr",
    }
  ];

  const tryggeLokalSamfunnActivitiesToDisplay: Array<ActivityRow> = [
    {
      displayName: "Omsorgsberedskap",
      fieldName: "omsorgBeredskapForrigeAr",
      fieldNameNextYear: "omsorgBeredskapNavaerendeAr",
    },
    {
      displayName: "Trygghetstreff – brannsikkerhet for eldre",
      fieldName: "brannsikkerhetForEldreForrigeAr",
      fieldNameNextYear: "brannsikkerhetForEldreNavaerendeAr",
    },
    {
      displayName: "Egenberedskap – markering",
      fieldName: "egenberedskapForrigeAr",
      fieldNameNextYear: "egenberedskapNavaerendeAr",
    },
    {
      displayName: "Førstehjelp for eldre - opplæring og informasjon",
      fieldName: "forsteHjelpForEldreForrigeAr",
      fieldNameNextYear: "forsteHjelpForEldreNavaerendeAr",
    },
    {
      displayName: "Kløvertur",
      fieldName: "kloverTurForrigeAr",
      fieldNameNextYear: "kloverTurNavaerendeAr",
    },
    {
      fieldName: "kanskjeKommerKongenForrigeAr",
      fieldNameNextYear: "kanskjeKommerKongenNavaerendeAr",
      displayName: "Kanskje kommer kongen"
    },
  ]

  const submit = handleSubmit<AktivitetState>((getValues) => {
    postFormData(getValues, true);
  });

  useEffect(() => {
    setValue("foreningsNummer", currentForeningReportNumber);

    async function getAktiviteter() {
      const response = await axios.get(
        `${URLS.AKTIVITET_GET}${currentForeningReportNumber}`,
        {
          headers: {
            Accept: "application/json",
            "Content-type": "application/json",
          },
        }
      );
      console.log(response);
      Object.entries(response.data).forEach(([key, value]) => {
        // @ts-ignore
        setValue(key, value);
      });
    }

    getAktiviteter().then(() => console.log(getValues()));
  }, [currentForeningReportNumber, getValues, setValue]);

  const getActivityRow = (activity: ActivityRow) => (
    <tr>
      <td className="text-xl text-center border-b border-r border-sk-tertiary-blue p-5 cursor-pointer">
        {activity.displayName}
      </td>
      <td className="border-b border-r border-sk-tertiary-blue p-5 cursor-pointer">
          <div className="flex justify-center">
            <select
              className="border-b border-sk-tertiary-blue"
              name={activity.fieldName}
              ref={register}
            >
              <option value="" />
              <option>JA</option>
              <option>NEI</option>
            </select>
          </div>
      </td>
      <td className="border-b border-sk-tertiary-blue p-5 cursor-pointer">
        <div className="flex justify-center">
          <select name={activity.fieldNameNextYear} ref={register}>
            <option value="" />
            <option>JA</option>
            <option>NEI</option>
          </select>
        </div>
      </td>
    </tr>
  )

  const getHeaderRow = (header: string) => (
    <tr>
      <th className="border-b border-sk-tertiary-blue w-1/4 text-xl font-medium font-bold pt-8 pb-8">{header}</th>
      <th className="border-b border-sk-tertiary-blue w-1/4 text-xl font-medium font-bold pt-8 pb-8" />
      <th className="border-b border-sk-tertiary-blue w-1/4 text-xl font-medium font-bold pt-8 pb-8" />
    </tr>
  )

  return (
    <>
      <NavigationBar saveOnClick={saveOnClick} />
      <form onSubmit={submit}>
        <div>
          <div>
            <p className="text-black text-center text-2xl font-bold mt-2py-2 ">
              4. Aktiviteter{" "}
            </p>
          </div>
          {/*Table one starts here*/}
          <div className="flex flex-grow-0 flex-row m-auto justify-center transform scale-75 md:scale-75">
            <div className="mt-4 h-2/3 self-center justify-center bg-sk-button-selected border-2 border-sk-secondary-blue rounded-md shadow-2xl w-2/3">
              <div>
                <p className="text-black text-center text-2xl font-bold mt-4 py-2 pb-8">
                  4.1 Aktiviteter
                </p>
              </div>
              <table className="table-auto border-sk-tertiary-blue">
                <thead>
                  <tr className="border-b border-sk-tertiary-blue">
                    <th className="w-1/4 text-xl font-medium">Aktiviteter</th>
                    <th className="w-1/4 text-xl font-thin">
                      {`Lokalforeningen har utført denne aktiviteten i
                                    ${forrigeAr}`}
                    </th>
                    <th className="w-1/4 text-xl font-thin pr-8">
                      {" "}
                      {`Lokalforeningen har planer om å utføre
                                    denne
                                    aktiviteten i ${aar}`}
                    </th>
                  </tr>
                </thead>
                {getHeaderRow("Kvinnehelse")}
                {kvinnehelseAktiviter.map((activity: ActivityRow) => getActivityRow(activity))}
                {getHeaderRow("Trygge Lokalsamfunn")}
                {tryggeLokalSamfunnActivitiesToDisplay.map((activity: ActivityRow) => getActivityRow(activity))}
              </table>
            </div>
          </div>
          {/*This is the go back and forward buttons*/}
          <FooterButtons
            previousLocation="/eiendom"
            saveOnClick={saveOnClick}
            isSubmitting={isSubmitting}
          />
        </div>
      </form>
    </>
  );
};

export default Aktivitet;
